const featureFlags = Object.freeze({
  SLA_ANALYSIS: 'SLA_ANALYSIS'
})

export default featureFlags
